import { HomeWrap } from "./HomeWrap";
import { APP_STORE_URL } from "@/lib/appStore";

const SECONDARY = [
  {
    quote:
      "I find cool new coffee shops around me. I'm a remote worker so it's super helpful to see if there are outlets and the vibe of the cafe.",
    name: "Ben",
  },
  {
    quote:
      "From helping me save time to find a coffee shop with what I need, to being able to save all of my past visits in one spot. It's been a game changer in helping me maximize my work sessions.",
    name: "Stephen",
  },
];

const Stars = () => (
  <div aria-hidden="true" className="mb-3 text-sm tracking-[2px] text-[#C9A227]">
    ★★★★★
  </div>
);

export function HomeReviews() {
  return (
    <section className="border-t border-[#E2D5C0] bg-[#F2EADC] py-[78px] max-[820px]:py-14">
      <HomeWrap>
        <h2 className="font-display text-[clamp(26px,3vw,34px)] font-semibold tracking-[-0.015em] text-[#3B2314]">
          What people say
        </h2>

        <div className="mt-[38px] grid gap-[26px] rounded-2xl border border-[#E4D8C6] bg-white p-[34px] min-[860px]:grid-cols-[1.5fr_.8fr] min-[860px]:items-center min-[860px]:gap-11">
          <blockquote className="m-0">
            <Stars />
            <p className="font-display text-[clamp(24px,2.7vw,31px)] leading-[1.3] text-[#3B2314]">
              &ldquo;I hate showing up to a coffee shop only to find out they don't have wifi or
              enough outlets. This app lets me check all of that before I go, which saves me so much
              time.&rdquo;
            </p>
            <div className="mt-[18px] text-sm text-[#8A7563]">Billie · App Store review</div>
          </blockquote>
          <div className="border-t border-[#E4D8C6] pt-5 min-[860px]:border-l min-[860px]:border-t-0 min-[860px]:py-1.5 min-[860px]:pl-10">
            {/* The design proposed a new sentence here. The page's existing
                line does the same job, and existing copy is not up for
                rewriting, so the design's structure carries the current words. */}
            <p className="max-w-[26ch] text-base leading-[1.5] text-[#7B4F2E]">
              From reviews on the App Store.
            </p>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-[14px] inline-block border-b border-[#E2D5C0] pb-0.5 text-[15.5px] font-semibold text-[#3B2314] no-underline"
            >
              Read them on the App Store →
            </a>
          </div>
        </div>

        <div className="mt-5 grid gap-6 min-[860px]:grid-cols-2">
          {SECONDARY.map((q) => (
            <figure key={q.name} className="m-0 rounded-2xl border border-[#E4D8C6] bg-white p-6">
              <Stars />
              <blockquote className="m-0 font-display text-[19.5px] leading-[1.38] text-[#3B2314]">
                &ldquo;{q.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-4 text-[13.5px] text-[#8A7563]">
                {q.name} · App Store review
              </figcaption>
            </figure>
          ))}
        </div>
      </HomeWrap>
    </section>
  );
}
